// @vendors
const Immutable = require('immutable');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const initialState = Immutable.fromJS({
    alerts: [],
    isFetching: false,
    error: false,
});

const RAAlerts = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_ALERTS_REQUEST:
            return state.merge({ isFetching: true, error: null, alerts: [] });
        case actionTypes.RA_ALERTS_FAILURE:
            return state.merge({ isFetching: false, error: true });
        case actionTypes.RA_ALERTS_SUCCESS:
            return state.mergeDeep({
                isFetching: false,
                alerts: action.payload.data,
            });
        default:
            return state;
    }
};

module.exports = RAAlerts;
